import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Route } from '@angular/router';
import { OrganizationService } from '../../../services/organization.services';
import { CommonModule } from '@angular/common';
import { SidebarModule } from 'primeng/sidebar';
import { TabMenuModule } from 'primeng/tabmenu';
import { ButtonModule } from 'primeng/button';
import { FormsModule, ReactiveFormsModule, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { FileUploadModule } from 'primeng/fileupload';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { DialogModule } from 'primeng/dialog';
import { DropdownModule } from 'primeng/dropdown';
import { TableModule } from 'primeng/table';
import { SplitButtonModule } from 'primeng/splitbutton';
import { MenuItem, } from 'primeng/api';
import { InputTextModule } from 'primeng/inputtext';
import { MenuModule } from 'primeng/menu';
import { ToolbarModule } from 'primeng/toolbar';
import { CampusComponent } from "../campus-section/campus-section.component";
import { DepartmentComponent } from '../department-section/department-section.component';
import { UserSectionComponent } from '../user-section/user-section.component';
import { UpdateOrgnaizationComponent } from "../update-orgnaization/update-orgnaization.component";
import { RolesComponent } from "../roles/roles.component";
import { CounterComponent } from "../counter/counter.component";
import { CoursesComponent } from "../courses/courses.component";
import { OrgnizationPackageComponent } from "../orgnization-package/orgnization-package.component";
import { OrgnaizationConfigComponent } from "../orgnaization-config/orgnaization-config.component";


interface UploadResponse {
  imageUrl: string;
}
@Component({
  selector: 'app-organization-details',
  standalone: true,
  imports: [CommonModule, SidebarModule, TabMenuModule, ButtonModule, FormsModule, ReactiveFormsModule, FileUploadModule, DialogModule, DropdownModule,
    TableModule, MenuModule, HttpClientModule, ToolbarModule,
    SplitButtonModule,
    InputTextModule, CampusComponent, UserSectionComponent, DepartmentComponent, UpdateOrgnaizationComponent, RolesComponent, CounterComponent, CoursesComponent, OrgnizationPackageComponent, OrgnaizationConfigComponent],
  templateUrl: './organization-details.component.html',
  styleUrls: ['./organization-details.component.scss']
})
export class OrganizationDetailsComponent implements OnInit {

 
  orgId!: string;
  orgData: any;
  imageUrl: SafeUrl | undefined;
  orgForm!: FormGroup;
  activeTab = 'details';

  campusSearch = '';

  searchText: string = '';
  searchAttribute: string = 'name';
  statuses = [
    { label: 'Active', value: 'Active' },
    { label: 'Inactive', value: 'Inactive' }
  ];


  tabs = [
    { label: 'Organization Details', value: 'details' },
    { label: 'Campus', value: 'campus' },
    { label: 'Departments', value: 'departments' },
    { label: 'Counter', value: 'counter' },
    { label: 'Roles', value: 'roles' },
    { label: 'Users', value: 'users' },
    {label: 'Organization Package', value: 'packages'},
    { label: 'Courses', value: 'courses' },
    { label: 'Organization Config', value: 'organizationConfig' }
  ];
  campusList: any[] = [];
  departmentList: any[] = [];
  rolesList: any[] = [];
  usersList: any[] = [];
  statusOptions = [
    { label: 'Active', value: 'active' },
    { label: 'Inactive', value: 'inactive' }
  ];
  campusActions: MenuItem[] = [];
  //selectedCampus: any = null;

  constructor(private route: ActivatedRoute, private orgService: OrganizationService, private fb: FormBuilder, private http: HttpClient, private sanitizer: DomSanitizer) {
    {

    }
  }

  ngOnInit(): void {

    this.orgForm = this.fb.group({});
    this.route.params.subscribe(params => {
      this.orgId = params['id'];
      this.fetchAllData();
    });

  }

  fetchAllData() {
    this.fetchOrganization();
  }

  fetchOrganization() {
    this.orgService.getOrganizationById({ organization_id: this.orgId }).subscribe({
      next: (data) => {
        this.orgData = data?.data || data;
        // Check for logo field and build full image URL
        const logoPath = this.orgData?.logo;
        if (logoPath) {
          const fullImageUrl = logoPath.startsWith('http')
            ? logoPath
            : environment.upload + logoPath;

          this.imageUrl = this.sanitizer.bypassSecurityTrustUrl(fullImageUrl);
        }
        // Dynamically create form controls from orgData
        for (const key of Object.keys(this.orgData)) {
          this.orgForm.addControl(
            key,
            this.fb.control(this.orgData[key])
          );
        }
      },
      error: (err) => console.error('❌ Failed to fetch organization:', err)
    });
  }


  fetchDepartments() {
    this.orgService.getAllDepartment({ organization_id: this.orgId }).subscribe({
      next: (res) => this.departmentList = res.data || res,
      error: (err) => console.error('❌ Departments error:', err)
    });
  }

  fetchRoles() {
    this.orgService.getAllRoles({ organization_id: this.orgId }).subscribe({
      next: (res) => this.rolesList = res.data || res,
      error: (err) => console.error('❌ Roles error:', err)
    });
  }

  fetchUsers() {
    this.orgService.getAllUsers({ organization_id: this.orgId }).subscribe({
      next: (res) => this.usersList = res.data || res,
      error: (err) => console.error('❌ Users error:', err)
    });
  }
  handleFileChange(event: any): void {
    const file = event.target.files[0];
    if (file) {
      const formData = new FormData();
      formData.append('file', file);
      this.http.post<UploadResponse>(environment.upload, formData).subscribe({
        next: (res) => {
          console.log('✅ Image uploaded!', res);
          const url = res.imageUrl.startsWith('http')
            ? res.imageUrl
            : `${environment.upload}${res.imageUrl}`;
          this.imageUrl = this.sanitizer.bypassSecurityTrustUrl(url);
          this.orgForm.patchValue({ logo: res.imageUrl });
          this.orgData.logo = res.imageUrl;
        },
        error: (err) => {
          console.error('❌ Image upload failed', err);
          // Add more detailed logging here
          if (err.status === 502) {
            alert('Server error while uploading the image. Please try again later.');
          } else {
            alert('An unexpected error occurred. Please check the console for details.');
          }
        }
      });
    }
  }


  getOrgKeys(data: any): string[] {
    return Object.keys(data);
  }

  formatValue(value: any): string {
    if (Array.isArray(value)) {
      return value.map(v => typeof v === 'object' ? JSON.stringify(v, null, 2) : v).join(', ');
    }
    if (typeof value === 'object' && value !== null) {
      return JSON.stringify(value, null, 2);
    }
    return value;
  }

}



